var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oz-toggle',{attrs:{"title":"Incluir preço do condomínio","initial-value":_vm.initialValue,"disabled":_vm.loading},on:{"filters:update":_vm.onRentTotalPriceChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }